/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { IxcAssetsV1AssetCommandServiceGetLogoGetLogoRequest } from '@interxfi/types';

export const IXC_ASSETS_V1_ASSET_COMMAND_SERVICE_GET_LOGO_AUDIENCE = ['clearing', 'program'];

export async function ixcAssetsV1AssetCommandServiceGetLogo(baseUrl: string | undefined, request?: IxcAssetsV1AssetCommandServiceGetLogoGetLogoRequest, requestInit?: RequestInit): Promise<undefined> { return makeRequest<undefined, IxcAssetsV1AssetCommandServiceGetLogoGetLogoRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/ixc/assets/v1/asset/c/:assetId/logo', request, requestInit)); }

